<template>
  <nuxt />
</template>

<script>
export default {
  middleware: ['fetchUser', 'initializer', 'guestInvite']
}
</script>
